window._ = require('lodash');
//window.__ = require('underscore');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');




    require('bootstrap');
} catch (e) {}


window.datetimepicker= require('jquery-datetimepicker');
//window.jQuery.datetimepicker.setLocale('es');


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
/*
 import Echo from 'laravel-echo';


 window.Pusher = require('pusher-js');

 window.Echo = new Echo({
   broadcaster: 'pusher',
   key: process.env.MIX_PUSHER_APP_KEY,
   cluster: process.env.MIX_PUSHER_APP_CLUSTER,
   httpHost: '45.55.232.37',
   wsHost: '45.55.232.37',
   wssHost: '45.55.232.37',
   wsPort: 8080,
   wssPort:8080,
   httpsPort:8080,
   httpPort: 8080,
   encrypted: false,
   useTLS:false,
   forceTLS: false,
   disableStats: true,
 });

*/


/*
 window.Echo = new Echo({
   broadcaster: 'pusher',
   key: process.env.MIX_PUSHER_APP_KEY,
   cluster: process.env.MIX_PUSHER_APP_CLUSTER,
   httpHost: 'tipificador.com',
   wsHost: 'tipificador.com',
   wssHost: 'tipificador.com',
   encrypted: false,
   useTLS:false,
   forceTLS: false,
   disableStats: true,
 });


 window.Echo = new Echo({
   broadcaster: 'pusher',
   key: process.env.MIX_PUSHER_APP_KEY,
   cluster: process.env.MIX_PUSHER_APP_CLUSTER,
   httpHost: process.env.PUSHER_HOST,
   wsHost: process.env.PUSHER_HOST,
   wssHost: process.env.PUSHER_HOST,
   wsPort: process.env.PUSHER_PORT,
   wssPort:process.env.PUSHER_PORT,
   httpsPort:process.env.PUSHER_PORT,
   httpPort: process.env.PUSHER_PORT,
   encrypted: false,
   useTLS:false,
   forceTLS: false,
   disableStats: true,
 });



 */
